import {
  REQUEST_FORM_SUBMISSION,
  FORM_SUBMISSION_ERROR,
  FORM_SUBMISSION_SUCCESS,
  RECEIVE_ALTERNATE_DATE_SELECTION,
  CLEAR_FORM_ERRORS
} from '../actions/forms';

const initialState = {
  isLoading: false,
  hasErrors: false,
  successfullySubmitted: false,
  alternateDateSelection: null,
}

const rfpForm = (state = initialState, action) =>  {
  switch (action.type) {
    case REQUEST_FORM_SUBMISSION:
      return Object.assign({}, state, {
        isLoading: true,
      })
    case FORM_SUBMISSION_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: false,
        successfullySubmitted: true
      })
    case FORM_SUBMISSION_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: true,
      })
    case RECEIVE_ALTERNATE_DATE_SELECTION:
      return Object.assign({}, state, {
        alternateDateSelection: action.payload
      })
    case CLEAR_FORM_ERRORS:
      return Object.assign({}, state, {
        hasErrors: false,
      })
    default: return state;
  }
}

export default rfpForm;